import { render } from "./ProjectInvestors.vue?vue&type=template&id=630af327&scoped=true"
import script from "./ProjectInvestors.vue?vue&type=script&lang=js"
export * from "./ProjectInvestors.vue?vue&type=script&lang=js"

import "./ProjectInvestors.vue?vue&type=style&index=0&id=630af327&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630af327"]])

export default __exports__